import { render, staticRenderFns } from "./PopoverResponsavel.vue?vue&type=template&id=32b317f2"
import script from "./PopoverResponsavel.vue?vue&type=script&lang=js"
export * from "./PopoverResponsavel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports